import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { useDispatch, useSelector } from 'react-redux';
import CopyToClipboard from 'common/components/copy-to-clipboard/copy-to-clipboard';
import { selectSiteId } from 'features/topbar/selectedSiteSlice';

export const SiteSetup: FC = () => {
  const dispatch = useDispatch();
  const siteId = useSelector(selectSiteId);

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full min-h-1/2-screen grow basis-full">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Integrating Tracking Tag
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              To get started, just drop our tracking tag on your website, and
              within minutes we will collect data about Visitors, Companies,
              Sources, Keywords, Referrals, and Pages.
            </p>
            <p className="font-bold mt-2">
              Simply copy and paste the following code onto each page just
              before the {'</body>'} tag:
            </p>
            <div className="border border-neutral-200 mt-2 p-2 flex items-start">
              <code className="whitespace-pre">
                {'<script type="text/javascript">\n'}
                {'  var __raconfig = __raconfig || {};\n'}
                {`  __raconfig.uid = "${siteId}";\n`}
                {'  __raconfig.action = "track";\n'}
                {'  (function () {\n'}
                {'    var ra = document.createElement("script");\n'}
                {'    ra.type = "text/javascript";\n'}
                {
                  '    ra.src = "https://ruler.nyltx.com/lib/1.0/ra-bootstrap.min.js";\n'
                }
                {'    var s = document.getElementsByTagName("script")[0];\n'}
                {'    s.parentNode.insertBefore(ra, s);\n'}
                {'  }());\n'}
                {'</script>'}
              </code>
              <div className="ml-auto">
                <CopyToClipboard
                  code={`<script type="text/javascript">\n  var __raconfig = __raconfig || {};\n  __raconfig.uid = "${siteId}";\n  __raconfig.action = "track";\n  (function () {\n    var ra = document.createElement("script");\n    ra.type = "text/javascript";\n    ra.src = "https://ruler.nyltx.com/lib/1.0/ra-bootstrap.min.js";\n    var s = document.getElementsByTagName("script")[0];\n    s.parentNode.insertBefore(ra, s);\n  }());\n</script>`}
                />
              </div>
            </div>
          </div>
        </section>
      </TileWithoutDefaultStyling>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full  grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Form Tracking
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              For manual form tracking please visit our
              <a
                href="https://ruler-documentation.readme.io/docs/form-tracking"
                className="text-primary-100"
              >
                {' '}
                documentation.
              </a>
            </p>
          </div>
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
